/**
 * @class Nagra Types
 */
export class NagraTypes {
    static CONTENT_TYPE = {
        BTV: 'BTV',
        VOD: 'VOD',
        SERIES: 'SERIES',
        SEASON: 'SEASON',
        DEEPLINK: 'DEEPLINK',
    }
    static RECOMMENDATION_TYPE = {
        VOD: 'related-vod',
        BTV: 'related-btv',
        EPL: 'related-epl', // recommendation type related to EPL (English Premier League) games
        UNKNOWN: 'unknown',
    }
    static HARDWARE_OS = {
        ANDROID: 'Android',
        IOS: 'iOS',
        WINDOWS: 'Windows',
        LINUX: 'Linux',
        COMPUTER: 'Computer',
    }

    static HARDWARE_TYPE = {
        STB: 'STB',
        AMAZON_TV: 'fireTV',
        MOBILE: 'IFSMobile', // Starhub ask to prefix by 'IFS' to differentiate IFS devices than legacy devices
        CHROMECAST: 'Chromecast',
        APPLE_TV: 'Apple TV',
        XBOX: 'XBox',
        PLAYSTATION: 'PS',
        SMART_TV: 'SmartTV',
        BROWSER: 'IFSBrowser', // Starhub ask to prefix by 'IFS' to differentiate IFS devices than legacy devices
    }
}
